const isNumberic = (value: any) => /^\d+$/.test(value);

export default isNumberic;
